import { Modal } from 'react-bootstrap'
import { useState, useEffect } from 'react'

// import {ToastMessageContainer} from '../../../../../_ePulse/layout/components/ToastMessageContainer'
import { toast } from 'react-toastify'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import useApi from '../../../../../../hooks/useQuery'
import { ADD_NEW_LAB_ROOM, GET_SELECTED_PRODUCTS } from '../../../GraphQLQueries/ProductOffering'
import useMutationApi from '../../../../../../hooks/useMutation'
import { stringify } from 'querystring'

export const CreateLabModal = (props: any) => {
  const [labName, setLabName] = useState<any>(null)
  
  const [options, setOptions] = useState<any[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
 
  const { createData: createLab, loading: addLoading, error: addError, data: addData } = useMutationApi(ADD_NEW_LAB_ROOM);

   const {
      loading: loadingData,
      error: MedicineError,
      data: productData,
      refetch: refetchList,
    } = useApi("", GET_SELECTED_PRODUCTS, {})

  const handleCreateLab = async() => {
    if (!labName || !selectedProduct) {
      toast.error('Please fill all the fields')
      return
    }
    console.log("Selected Product:", selectedProduct.value);

    const testLabsInput = {
  roomName:labName,
      roomType: selectedProduct?.value,
      roomTypeId: selectedProduct?.id
    }
    

   try{
   await createLab( {testLabsInput:testLabsInput});
   toast.success('Lab added sucessfully!')

   props.onClose()

   }catch(e){
   console.error("Error creating lab:", e);
   }
  }


    useEffect(() => {
        if(productData && productData.getBusinessProductOffering) {
            const newData = productData.getBusinessProductOffering.map((data:any) => ({
            id: data?.productId,
            label: data?.productName,   
            value: data?.productValue,
            }));
            
            console.log("productData", newData);
                        setOptions(newData);
        }

    }, productData);

    const handleChange = (event:any) => {
      const selectedValue = event.target.value;
      console.log("Selected Value:", selectedValue);
  const selected = options.find(option => option.label === selectedValue);
  console.log("Selected Option:", selected);
  setSelectedProduct(selected || null);
    };

  return (
    <Modal
      show={true}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.onClose()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <div>
          <ToastMessageContainer />
        </div>
        <span className='fs-3 fw-bold'>Add New Lab</span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>
        <div className='modal-body'>
          <div className='form-group'>
            <label>Lab Name</label>
            <input

              type='text'
              className='form-control'
              placeholder='Enter Lab Name'
              value={labName}
              onChange={(e) => setLabName(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Products Offered</label>
                <div>
            <select className='form-control' value={selectedProduct!==null ? selectedProduct.label : ''} onChange={handleChange}>
                <option value="" disabled>Select an option</option>
                {options.map((option, index) => (
                    <option key={index} value={option.label}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
          </div>
        </div>

        <div className='btn-row'>
            <button
            className='ePulse-btn-primary'
            type='button'
            onClick={() => {
handleCreateLab()
            }}
            >
             Create
            </button>
        </div>
      </div>
    </Modal>
  )
}
